import React from "react";
import "./WeBuyWeSell.css";
import { Helmet } from "react-helmet-async";

const title = "We Buy. We Sell";
const pageTitle = "We Buy. We Sell | Respected Solutions";
const metaDescription =
  "Turn your gold, diamonds, luxury wristwatches, and jewelry into instant cash with Respected Solutions. Fair, fast, and secure transactions every time.";

const WeBuyWeSell = () => {
  return (
    <section className="we-buy-sell-container">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "We Buy. We Sell",
            provider: {
              "@type": "Organization",
              name: "Respected Solutions",
            },
            areaServed: "NG",
          })}
        </script>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="we-buy-sell-hero-slide"
        style={{
          backgroundImage: `url(/assets/images/rs/watch_buy_&_sell.jpg)`,
        }}
      >
        <div className="we-buy-sell-hero-overlay">
          <div className="we-buy-sell-hero-content">
            <h1>{title}</h1>
            <p>Old treasures, new opportunities!</p>
          </div>
        </div>
      </div>

      <div className="we-buy-sell-inner">
        <div className="we-buy-sell-inner-content">
          <section className="we-buy-sell-intro">
            <p>
              Turn your gold, diamonds, luxury wristwatches, and jewelry into
              instant cash even if they’re broken, worn, or damaged. With gold
              prices rising, even small items can bring a surprisingly big
              payout. At Respected Solutions, every transaction is fast, safe,
              and fair.
            </p>
            <p>
              <em>“Old treasures, new opportunities!”</em>
            </p>
          </section>

          <section className="we-buy-sell-list">
            <h2>We Also Buy:</h2>
            <ul>
              <li>All carat Gold</li>
              <li>White Gold</li>
              <li>Gold Bars</li>
              <li>Diamonds</li>
              <li>Luxury Wristwatches</li>
              <li>Jewelries</li>
            </ul>
          </section>

          <section className="we-buy-sell-steps">
            <h2>Ready to Sell – Quick and Easy?</h2>
            <ul>
              <li>
                <strong>Step 1 – Bring It In:</strong> Drop by any of our
                branches with your valuables, and a valid ID. No stress, our
                team will guide you every step of the way.
              </li>
              <li>
                <strong>Step 2 – Get Your Offer:</strong> Our experts give your
                items a fair, competitive valuation on the spot. No hidden fees,
                no long waits.
              </li>
              <li>
                <strong>Step 3 – Walk Away Paid:</strong> Love the offer? Get
                your cash instantly in hand or directly to your bank account.
                It’s that simple.
              </li>
              <li>
                <strong>Step 4 – Not Ready to Sell?</strong> No worries! Take
                your items back... no pressure, no hassle.
              </li>
            </ul>
          </section>

          <section className="we-buy-sell-security">
            <h2>Identity Verification</h2>
            <p>
              To ensure the security of all transactions and protect against
              fraud, we verify your identity and address before completing any
              sale.
            </p>
          </section>

          <section className="we-buy-sell-car-auto">
            <h2>Car & Auto Loans</h2>
            <p>
              Loan against car Nigeria, car equity loan Lagos, pawn car for cash
              Nigeria, quick cash for car Lagos, car collateral loan Abuja, pawn
              and park Abuja. Learn how car pawn works Nigeria for secure,
              hassle-free loans.
            </p>
          </section>

          <section className="we-buy-sell-estimate">
            <h2>Get an Online Estimate</h2>
            <p>
              Want to know what your valuables are worth before visiting us?
              (Fill out our online enquiry form or reach out to us), and we’ll
              provide a preliminary estimate for your items.
            </p>
            <a href="/contact-us" className="we-buy-we-sell-enquire-btn">
              Enquire Now
            </a>
          </section>
        </div>
      </div>
    </section>
  );
};

export default WeBuyWeSell;
